import useContentfulSearchFormHeadlines from '@/hooks/useContentfulSearchFormHeadlines'
import { HEADERS } from '@/components/SearchForm/constants'

const useHeadlineValues = (currentTab: string) => {
  const hotels = useContentfulSearchFormHeadlines(
    'searchFormHotels',
    currentTab === 'hotels'
  )
  const flights = useContentfulSearchFormHeadlines(
    'searchFormFlights',
    currentTab === 'flights'
  )
  const vacations = useContentfulSearchFormHeadlines(
    'searchFormVacations',
    currentTab === 'vacations'
  )
  const cars = useContentfulSearchFormHeadlines(
    'searchFormCars',
    currentTab === 'cars'
  )

  const cruises = useContentfulSearchFormHeadlines(
    'searchFormCruises',
    currentTab === 'cruises'
  )

  return {
    hotels: hotels || HEADERS.hotels,
    flights: flights || HEADERS.flights,
    vacations: vacations || HEADERS.vacations,
    cars: cars || HEADERS.cars,
    cruises: cruises || HEADERS.cruises
  }
}

export default useHeadlineValues
